export function appendHomePageDataToUrl(targetMentors: string[], url: string) {
  const time = new Date().toISOString();
  const data = {
    targetMentors,
    time,
  };

  const urlObject = new URL(url);
  urlObject.searchParams.set("leftHomePage", JSON.stringify(data));

  return urlObject.toString();
}
